import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectDptoInsUpd } from "../../../redux/dpto/dptoInsUpdSlice";
import { assertImagesUrl } from "../../../redux/common";

export function DptoInsUpdReview() {
    const dptoInsUpd = useSelector(selectDptoInsUpd);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão
        </Typography>
        <Grid container spacing={3}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{dptoInsUpd.dpto.name}</Typography>
            </Grid>
        </Grid>
        <Divider flexItem />
        
        <Grid size={10}>
            <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                <Avatar
                    src={assertImagesUrl(dptoInsUpd.dpto.url)}
                    alt={dptoInsUpd.dpto.name}
                    sx={{ width: 60, height: 60, border: "1px solid #ccc" }}
                />
            </Box>
        </Grid>
        <Divider flexItem />

    </>;
}